/**
 * The report-offer card's shape and its launch-lock key.
 *
 * Deliberately its OWN module rather than living in
 * `global-ai-transcript-messages.tsx` with the components that render these
 * offers: `assistant-engine-core.ts` needs the key builder at RUNTIME, and
 * that `.tsx` evaluates a module-level emotion `keyframes` on import — so the
 * one value import would have pulled Chakra + emotion into the engine core's
 * graph and quietly ended its framework-free property (every other import the
 * core makes from a `.tsx` is `import type`, fully erased). Three lines of
 * string join have no business dragging a render stack behind them.
 */

export type ReportOfferCardFields = {
  reportType: string;
  reportName: string;
  description?: string;
  sampleLink: string;
  confidence: number;
};

/**
 * Identity of an in-flight report launch: which message's card was clicked and
 * which report it offers. Stored in the engine store's
 * `reportOfferLaunchingKey` so exactly the clicked trigger pulses while every
 * other report trigger goes inert.
 */
export const buildReportOfferLaunchKey = (
  messageId: string,
  reportType: string
): string => `${messageId}:${reportType}`;
